import { MergeConnectButton } from '@/features/integrations-connected-apps/merge-agent-handler/components/merge-connect-button';
import { NangoConnectButton } from '@/features/integrations-connected-apps/nango/components/nango-connect-button';
import { resolveConnectAppOptions } from '@/features/projects/components/connectAppChips.defaults';
import {
  ConnectRequiredBlock as ConnectRequiredBlockView,
  type ConnectRequiredBlockProps,
  type ConnectRequiredButtonArgs,
} from '@heidi/agents';
import { ConnectedAppIcon } from '@heidi/integrations/connected-apps';

const renderConnectButton = ({
  option,
  stack,
  onConnected,
  onFailed,
  onBusyChange,
  children,
}: ConnectRequiredButtonArgs) =>
  stack === 'nango' ? (
    <NangoConnectButton
      allowedIntegrations={[option.id]}
      compact
      testId={`nango-connect-${option.id}`}
      onBusyChange={onBusyChange}
      onConnected={() => onConnected(option.id)}
      onFailed={onFailed}
    >
      {children}
    </NangoConnectButton>
  ) : (
    <MergeConnectButton
      connector={option.id}
      compact
      onBusyChange={onBusyChange}
      onConnected={() => onConnected(option.id)}
      onFailed={onFailed}
    >
      {children}
    </MergeConnectButton>
  );

const renderAppIcon = (icon: { id: string; label?: string }) => (
  <ConnectedAppIcon {...icon} />
);

/**
 * Binds the connect card to the integrations side: the apps the payload's stack
 * can connect, that stack's OAuth button, and the app marks.
 */
export function ConnectRequiredBlock(props: ConnectRequiredBlockProps) {
  const stack = props.payload.stack;
  return (
    <ConnectRequiredBlockView
      {...props}
      options={stack ? resolveConnectAppOptions(props.payload.connectors, stack) : []}
      renderConnectButton={renderConnectButton}
      renderAppIcon={renderAppIcon}
    />
  );
}
